import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { BookOpen, Bell, CheckCircle, DollarSign } from 'lucide-react';

export default function StudentDashboard() {
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      {/* Greeting */}
      <div>
        <h2 className="font-outfit font-semibold text-3xl text-slate-800 mb-2">
          Good Morning, {user?.name}! 👋
        </h2>
        <p className="text-slate-500">Let's make today a great learning day!</p>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-xl bg-orange-100 flex items-center justify-center">
              <CheckCircle className="w-6 h-6 text-orange-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Attendance</p>
              <p className="text-2xl font-outfit font-bold text-slate-800">92%</p>
            </div>
          </div>
          <p className="text-sm text-slate-500">Great attendance this month!</p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center">
              <BookOpen className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Homework</p>
              <p className="text-2xl font-outfit font-bold text-slate-800">3</p>
            </div>
          </div>
          <p className="text-sm text-slate-500">Pending assignments</p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center">
              <DollarSign className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Fee Status</p>
              <p className="text-xl font-outfit font-bold text-green-600">Paid</p>
            </div>
          </div>
          <p className="text-sm text-slate-500">All fees up to date</p>
        </div>
      </div>

      {/* Recent Announcements */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
        <div className="flex items-center gap-3 mb-6">
          <Bell className="w-5 h-5 text-orange-600" />
          <h3 className="font-outfit font-semibold text-xl text-slate-800">Recent Announcements</h3>
        </div>
        <div className="space-y-3">
          <div className="p-4 bg-slate-50 rounded-xl">
            <p className="font-medium text-slate-800">Parent-Teacher Meeting</p>
            <p className="text-sm text-slate-500 mt-1">Scheduled for next Saturday at 10 AM</p>
          </div>
          <div className="p-4 bg-slate-50 rounded-xl">
            <p className="font-medium text-slate-800">Sports Day Coming Up</p>
            <p className="text-sm text-slate-500 mt-1">Annual sports day on 15th March</p>
          </div>
        </div>
      </div>
    </div>
  );
}
